import { connect } from 'react-redux';
import TinyJPBanker from '../views/tiny/TinyJPBanker';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyJPBankerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyJPBanker);

export default TinyJPBankerContainer;
